__turbopack_context__.v({
  "accentLine": "FoodCategoryShowcase-module-scss-module__LujK-W__accentLine",
  "active": "FoodCategoryShowcase-module-scss-module__LujK-W__active",
  "animate": "FoodCategoryShowcase-module-scss-module__LujK-W__animate",
  "cardLink": "FoodCategoryShowcase-module-scss-module__LujK-W__cardLink",
  "carousel": "FoodCategoryShowcase-module-scss-module__LujK-W__carousel",
  "dot": "FoodCategoryShowcase-module-scss-module__LujK-W__dot",
  "dragging": "FoodCategoryShowcase-module-scss-module__LujK-W__dragging",
  "grid": "FoodCategoryShowcase-module-scss-module__LujK-W__grid",
  "gridCard": "FoodCategoryShowcase-module-scss-module__LujK-W__gridCard",
  "image": "FoodCategoryShowcase-module-scss-module__LujK-W__image",
  "indicators": "FoodCategoryShowcase-module-scss-module__LujK-W__indicators",
  "label": "FoodCategoryShowcase-module-scss-module__LujK-W__label",
  "labelText": "FoodCategoryShowcase-module-scss-module__LujK-W__labelText",
  "showcase": "FoodCategoryShowcase-module-scss-module__LujK-W__showcase",
  "slide": "FoodCategoryShowcase-module-scss-module__LujK-W__slide",
  "slideUpFade": "FoodCategoryShowcase-module-scss-module__LujK-W__slideUpFade",
  "track": "FoodCategoryShowcase-module-scss-module__LujK-W__track",
});
